import { Input } from "antd";
import styled from "styled-components";

export const PickerInput = styled(Input)`
  &.ant-input-affix-wrapper .ant-input-suffix {
    width: 14px;
    justify-content: center;
  }

  &.ant-input-affix-wrapper .ant-input-clear-icon {
    display: none;
    margin: 0;
  }

  &.ant-input-affix-wrapper:hover
    .ant-input-clear-icon:not(.ant-input-clear-icon-hidden) {
    display: inline-flex;
  }

  &.ant-input-affix-wrapper:hover
    .ant-input-clear-icon:not(.ant-input-clear-icon-hidden)
    + .anticon-clock-circle {
    display: none;
  }
`;

export const PickerPanel = styled.div`
  margin: -12px -16px;

  .time-columns {
    display: flex;
  }

  .time-column {
    position: relative;
    width: 64px;
    height: 224px;
    overflow-y: auto;
    overscroll-behavior: contain;

    & + .time-column {
      border-left: 1px solid #f0f0f0;
    }

    button {
      display: block;
      width: 100%;
      height: 28px;
      padding: 0;
      border: 0;
      background: transparent;
      color: rgba(0, 0, 0, 0.85);
      font: inherit;
      cursor: pointer;

      &:hover:not(:disabled),
      &:focus-visible {
        background: #f5f5f5;
      }

      &[aria-selected="true"] {
        background: #e6f7ff;
        font-weight: 600;
      }

      &:disabled {
        color: rgba(0, 0, 0, 0.25);
        cursor: not-allowed;
      }
    }
  }

  .time-footer {
    padding: 8px;
    border-top: 1px solid #f0f0f0;
    text-align: right;
  }
  .item-option {
    border-radius: 0px;
  }
`;
